import { Box, ButtonBase, Menu, Typography } from "@mui/material";
import DashboardCounts from "components/dashboard/dashboard-counts";
import DashboardTabs from "components/dashboard/dashboard-tabs";
import PayoutHistory from "components/dashboard/payout-history";
import PendingBookings from "components/dashboard/pending-bookings";
import UpcomingBookings from "components/dashboard/upcoming-bookings";
import DateSelectionPopover from "components/search-filters/date-selection-popover";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  getOwnerDashboardBookings,
  getOwnerDashboardPayouts,
  getOwnerDashboardStats,
  setDateRanges,
} from "slices/dashboardReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const DashboardPage = () => {
  const { dashboardReducer }: any = useAppSelector((state) => state);
  const { pendingRequests, upcomingBookings, payoutHistory } = dashboardReducer;
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<any | null>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    // dispatch(getOwnerDashboard());
    dispatch(
      getOwnerDashboardStats({
        start_date: dashboardReducer.startDate,
        end_date: dashboardReducer.endDate,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardReducer.startDate, dashboardReducer.endDate]);

  useEffect(() => {
    dispatch(getOwnerDashboardBookings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      getOwnerDashboardPayouts({ page: dashboardReducer?.payoutPage || 1 })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardReducer?.payoutPage]);

  return (
    <Box>
      <DashboardTabs tab="dashboard" />
      <Box sx={{ px: "3%", py: "20px" }}>
        <Box sx={{ mt: "15px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",

              mb: "25px",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  md: "24px",
                  lg: "24px",
                  xl: "24px",
                  sm: "18px",
                  xs: "18px",
                },
                fontWeight: 600,
                color: "#323232",
                lineHeight: {
                  md: "30px",
                  lg: "30px",
                  xl: "30px",
                  sm: "22px",
                  xs: "22px",
                },
              }}
            >
              Quick Stats
            </Typography>
            <ButtonBase
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // gap: "5px",
              }}
              id="basic-button"
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <Typography
                sx={{
                  color: "#A2A2A2",
                  fontWeight: "500",
                  fontSize: {
                    md: "13px",
                    lg: "13px",
                    xl: "13px",
                    sm: "11px",
                    xs: "11px",
                  },
                  lineHeight: "22px",
                }}
              >
                Date Range
              </Typography>
              <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
                <Typography
                  sx={{
                    color: "#383838",
                    fontWeight: "600",
                    fontSize: {
                      md: "15px",
                      lg: "15px",
                      xl: "15px",
                      sm: "11px",
                      xs: "11px",
                    },
                    lineHeight: "18px",
                  }}
                >
                  {moment(dashboardReducer.startDate).format("MMM DD, yyyy")} -{" "}
                  {moment(dashboardReducer.endDate).format("MMM DD, yyyy")}
                </Typography>
                <img
                  src="/assets/img/icons/calendar_bw.svg"
                  height="24px"
                  width="24px"
                  alt=""
                />
              </Box>
            </ButtonBase>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
            <DashboardCounts />
            {(upcomingBookings.length > 0 ||
              pendingRequests.length > 0 ||
              payoutHistory.length > 0) && (
              <>
                <UpcomingBookings />
                <PendingBookings />
                <PayoutHistory />
              </>
            )}
            {upcomingBookings.length === 0 &&
              pendingRequests.length === 0 &&
              payoutHistory.length === 0 && (
                <Box
                  sx={{
                    mx: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    my: "8%",
                  }}
                >
                  <img src="/assets/img/no-booking.png" alt="" width="271px" />
                  <Typography
                    sx={{
                      color: "#323232",
                      fontWeight: 700,
                      fontSize: "26px",
                      lineHeight: "31px",
                      mt: "20px",
                      mb: "10px",
                      textAlign: "center",
                    }}
                  >
                    No Bookings and Payout History Yet!
                  </Typography>
                  <Typography
                    sx={{
                      color: "#A2A2A2",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "24px",
                      mb: "15px",
                      textAlign: "center",
                    }}
                  >
                    Currently, there are no records available for your booking
                    and payout <br /> history. Stay tuned for future updates!
                  </Typography>
                </Box>
              )}
          </Box>
        </Box>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: { padding: "20px", borderRadius: "10px" },
        }}
      >
        <DateSelectionPopover
          handleClose={handleClose}
          onChange={(dates: any) =>
            dispatch(
              setDateRanges({
                start: moment(dates.start).format("yyyy-MM-DD"),
                end: moment(dates.end).format("yyyy-MM-DD"),
              })
            )
          }
        />
      </Menu>
    </Box>
  );
};

export default DashboardPage;
